


































import api from '@/lib/api';
import Vue from 'vue'
export default Vue.extend({
    data(){
        return {
            name: '',
            tickets: [] as ('white' | 'bronze' | 'silver' | 'gold' | 'platinum')[]
        }
    },
    methods: {
        async createCategory(){
            
            const res = await api.media.categories.createCategory(this.name, this.tickets);
            if(res.err){
                alert("di' a cippi che è successo un casino");
                return;
            }
            
        },  
        toggleChoose(item: 'white' | 'bronze' | 'silver' | 'gold' | 'platinum'){
      
            if(this.tickets.includes(item)){
                const index = this.tickets.findIndex(i => i === item);
                this.tickets.splice(index, 1);
            }else{
                this.tickets.push(item);
            }

        }
    }
})
